import AuthApi from '@apis/auth/AuthApi';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import useToast from '@hooks/ui/useToast';
import useProjectId from '@hooks/useProjectId';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import SignInContext from '../context/SignInContext';

interface Props {
    authNo: string,
}

function useVerification({
    authNo,
}: Props) {
    const { t } = useTranslation('signIn');
    const { useValue, useVerified } = useContext(SignInContext);
    const projectId = useProjectId();
    const [value] = useValue;
    const [_, setIsVerified] = useVerified;
    const toast = useToast();
    const isEmail = useIsEmailSignIn();
    const { mutate } = useMutation({
        mutationKey: ['verifySms', value, authNo, projectId],
        mutationFn: () => {
            if (isEmail) {
                return AuthApi.verifyEmail({
                    projectId, authNo, email: value,
                });
            }
            return AuthApi.verifySms({
                phoneNo: value,
                smsAuthNo: authNo,
                projectId,
            });
        },
        onSuccess() {
            setIsVerified(true);
            toast.success(t('toast.verificationComplete'));
        },
        onError() {
            toast.error(t('toast.verificationFailed'));
        },
    });
    return () => {
        console.log({ value });
        if (authNo) {
            mutate();
        }
    };
}

export default useVerification;
